import { TApiaFilter } from '@apia/util';
import { ISelectableState, TBasicRow } from './types';

export function getInitialState<
  ColumnsType extends { name: string },
  RowsType extends TBasicRow | string,
>(): ISelectableState<ColumnsType, TApiaFilter, RowsType> {
  return {
    allowEdition: false,
    allowSelection: true,
    columns: [],
    expandedRows: [],
    isEditionMode: false,
    isFocused: false,
    filters: [],
    focusedColumn: 0,
    focusedRow: 0,
    hasNonAdditionalFilters: false,
    isMultiple: true,
    nonAdditionalColumnsCount: 0,
    rows: [],
    selectedRows: [],
    statesColumns: 0,
  };
}
